/**
 * AUTH-POLICY §3.1 — 로그인 흐름 앱별 단일 진실 원천.
 * 정책 원문: shared/AUTH-POLICY.md
 */

/** §1 Entry — 모든 서브앱의 로그인 진입은 공용 허브로. 자체 OAuth 직접 호출 금지. */
const LOGIN_HUB = "https://teachermate.co.kr/login";

/**
 * §2 defaultAfterLogin — returnUrl 이 없을 때의 도착지.
 * studio 는 **빌더형**(랜딩에서 교사/학생 흐름이 갈라진다) → `/`.
 * 🚨 `/teacher` 로 두면 "랜딩 안 거치고 대시보드 직행" 회귀가 난다(§2 빌더형 `/` 동작 명세).
 */
export const defaultAfterLogin = "/";

/**
 * §1 Entry + §3.2 — returnUrl 은 "사용자가 직전 보던 절대 URL".
 * 이게 없으면 로그인 후 studio 로 돌아오지 못한다.
 */
export function getLoginUrl(currentHref: string = window.location.href): string {
  return `${LOGIN_HUB}?returnUrl=${encodeURIComponent(currentHref)}`;
}
